import { render } from "./TestProjectTable.vue?vue&type=template&id=7d646df7"
import script from "./TestProjectTable.vue?vue&type=script&lang=js"
export * from "./TestProjectTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__